// TravelDeliverables.js
import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Package, Map, CheckSquare, MessageSquare, TrendingDown } from 'lucide-react';

const TravelDeliverables = () => {
  const deliverables = [
    {
      id: 1,
      icon: FileText,
      title: "Personalized checklist",
      description: "(with file-naming and formatting rules)."
    },
    {
      id: 2,
      icon: Package,
      title: "Template pack",
      description: "(sponsor/employer/invitation letters, basic travel plan)."
    },
    {
      id: 3,
      icon: Map,
      title: "Case summary sheet",
      description: "mapping your documents to stated criteria."
    },
    {
      id: 4,
      icon: CheckSquare,
      title: "Final pre-submission admin QA checklist",
      description: ""
    },
    {
      id: 5,
      icon: MessageSquare,
      title: "Mock interview notes",
      description: "& practical improvement tips."
    },
    {
      id: 6,
      icon: TrendingDown,
      title: "If refused: written gap analysis",
      description: "focused on documentation."
    }
  ];

  return (
    <section className="py-16 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <motion.div 
          className="text-left mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-4xl font-inter font-bold text-acBlack">
            What you receive
          </h2>
        </motion.div>

        {/* Deliverables Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {deliverables.map((item, index) => {
            const IconComponent = item.icon;
            return (
              <motion.div
                key={item.id}
                className="text-left"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                {/* Icon */}
                <div className="flex items-start mb-6">
                  <div className="w-16 h-16 bg-acYellow rounded-full flex items-center justify-center flex-shrink-0">
                    <IconComponent className="w-8 h-8 text-white" />
                  </div>
                </div>

                {/* Content */}
                <h3 className="text-xl font-inter font-bold text-acBlack mb-3">
                  {item.title}
                </h3>
                {item.description && (
                  <p className="text-gray-600 leading-relaxed text-sm">
                    {item.description}
                  </p>
                )}
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TravelDeliverables;
